import React from 'react';
import { Loader2 } from 'lucide-react';

const AdminPageLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
    </div>
  );
};

export default AdminPageLoader;
